import { Flex, FlexProps, Spinner as ChakraSpinner, SpinnerProps } from '@chakra-ui/react';

export const Spinner = ({
    spinnerProps = {},
    ...rest
}: FlexProps & {
    spinnerProps?: SpinnerProps;
}) => {
    const { css, ...props } = spinnerProps;

    return (
        <Flex alignItems="center" justifyContent="center" p={4} {...rest}>
            <ChakraSpinner
                size="lg"
                color="secondary.solid"
                borderWidth="6px"
                animationDuration="0.6s"
                {...props}
                css={{
                    '--spinner-track-color': 'colors.secondary.subtle',
                    ...css,
                }}
            />
        </Flex>
    );
};
